import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";

export default function Statistics() {
  const lng = useGetUrlLocale();
  const { pageId } = useParams();

  useEffect(() => {
    document.title = "Statistics";
    document.body.style.overflow = "hidden";
    document.body.style.top = "";

    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      @media screen and (max-width: 991px) {
        body {
          padding-top: 67px;
        }
      }
    `;
    document.head.appendChild(styleElement);

    return () => {
      document.body.style.overflow = "";
      if (styleElement.parentNode) {
        styleElement.parentNode.removeChild(styleElement);
      }
    };
  }, []);

  const statisticsSrc = `${process.env.REACT_APP_STATISTICS_URL}${lng}/mepage?url=${process.env.REACT_APP_ME_PAGE_URL}${pageId ? `&id=${pageId}` : ""}`;

  return (
    <iframe
      className="w-100"
      style={{ minHeight: "100vh" }}
      src={statisticsSrc}
    />
  );
}
